$j(function () {
    //Popovers
    var popoverIsVisible = false;
    var popoverClicked = false;
    $j('[data-toggle="popover"]').popover({
        html: true,
        trigger: 'manual'
    }).click(function (e) {
        if (popoverIsVisible && popoverClicked) {
            $j('[data-toggle="popover"]').popover("hide");
            popoverIsVisible = popoverClicked = false;
        }
        else {
            $j(this).popover('show');
            popoverIsVisible = true;
            popoverClicked = false;
            e.preventDefault();
        }
    });

    // Accessibility: Open main navigation dropdown menus with enter key 
    $j(document).on("keydown",".dropdown", function(event) {
        var dropdown = $j(event.target.parentElement);
        if (event.keyCode === 13) { // enter key      
            // Toggle open
            if (document.activeElement.getAttribute("aria-expanded") == "false")  {
                dropdown.addClass("active");            
                dropdown.attr("id", "activeDropDownMenu");
                dropdown.children().first().attr("aria-expanded", "true");
                return false; //forces enter key to open menu without clicking header link
            // Toggle close
            } else {
                if (document.activeElement.className == "desktop") {
                    dropdown.removeClass("active");
                    dropdown.attr("id", "");
                    dropdown.children().first().attr("aria-expanded", "false");
                    return false; //forces enter key to close menu without clicking header link
                }
            }
            //close menu upon leaving 
            if (document.activeElement.offsetParent.className == 'dropdown' || document.activeElement.id == 'findAndBookBtn') {
                dropdown.siblings().removeClass("active");
                dropdown.siblings().attr("id", "");
                dropdown.siblings().children().first().attr("aria-expanded", "false");
            }
        }
        if (event.keyCode === 9 && event.shiftKey) {  // tab + shift || tab
            dropdown.removeClass("active");
            dropdown.attr("id", "");
            dropdown.children().first().attr("aria-expanded", "false");
        }
        //close previous menu when focusing on new menu
        $j(document).on("focus", ".dropdown", function(event) {
            var dropdown = $j(event.target.parentElement); 
            if (document.activeElement.parentElement.className == 'dropdown') {
                dropdown.siblings().removeClass("active");
                dropdown.siblings().attr("id", "");
                dropdown.children().first().attr("aria-expanded", "false");
             }
        });
        // Accessibility: Close active menu with escape key
        $j(document).on("keydown",".menuitem", function(event) {
            var dropdown; 
            if (event.keyCode === 27) { // esc
                dropdown = $j(event.target.closest(".dropdown"));
                dropdown.removeClass("active");
                dropdown.attr("id", "");
                dropdown.children().first().attr("aria-expanded", "false");
            }
            if (event.keyCode === 13) { // enter key  
                return true;
            }
        });

        $j('body').on('click', function (e) {
            if (popoverIsVisible && popoverClicked) {
                $j('[data-toggle="popover"]').popover("hide");
                popoverIsVisible = popoverClicked = false;
            } else {
                popoverClicked = true;
            }
        });
    });

    // Accessibility: Open/close "Find & Book" menu on homepage with enter key 
    $j(document).on("keydown","#bookNowButton", function(event) {
        var bookNowButton = $j(event.target);
        if (event.keyCode === 13) { // enter key         
            // Toggle open
            if (bookNowButton.children().first().children().attr("aria-expanded") == "false")  {
                bookNowButton.children().first().children().attr("aria-expanded", "true");
            // Toggle close
            } else {
                bookNowButton.children().first().children().attr("aria-expanded", "false");
            }
        }
    });
});
//toggles aria-expanded attribute on (currently just the remember me) popover tooltips. Eventually this should be reworked into the jquery callback
function changeExpanded(id) {
     var popover = document.getElementById(id);
     if (popover.getAttribute('aria-expanded') === 'false')  {
             popover.setAttribute('aria-expanded', 'true');
     } else {
         popover.setAttribute('aria-expanded', 'false');
     }
 }
//toggles aria-expanded attribute onclick for the Find & Book homepage modal
function changeExpandedBooker() {
     var bookNowButton = document.getElementsByClassName('brandBooker')[1];
   
     if (bookNowButton.getAttribute('aria-expanded') === 'false')  {
             bookNowButton.setAttribute('aria-expanded', 'true');
     } else {
         bookNowButton.setAttribute('aria-expanded', 'false');
     }
 }